import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

@Component({
  selector: 'app-worker-status',
  templateUrl: './worker-status.component.html',
  styleUrls: ['./worker-status.component.scss']
})
export class WorkerStatusComponent implements OnInit {

  workers: any;

  monitor = '';
  group = '';

  filter:any = {
    search: '',
    monitors: [],
    groups: [],
    status:[]
  }

  monitors:any = [];
  groups:any = [];
  statuses = [
    {'id':'ok','name':'Ok'},
    {'id':'overdue','name':'Overdue'},
    {'id':'help','name':'Help'},
    {'id':'','name':'Inactive'}
  ];

  u = Utils;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getWorkers();

  }

  getWorkers(){

    console.log(this.filter);

    let filter = { ...this.filter };

    filter.monitors = filter.monitors.join(",");
    filter.groups = filter.groups.join(",");
    filter.status = filter.status.join(",");

    //console.log(filter);

    this.okService.get('reports/workerstatus',filter)
    .subscribe((data) => {

      console.log(data.body);

      this.workers = data.body;
      this.groups = this.okService.groups;
      this.monitors = this.okService.monitors;

    });
  }

  updateFilter(){
    this.getWorkers();
  }

  clearFilter(){
    this.filter = {
      search: '',
      monitors: [],
      groups: [],
      status:[]
    }
    this.getWorkers();
  }

  export(){
    const fields: any = { ...this.filter, export: true };
    fields.monitors = Array.isArray(fields.monitors) ? fields.monitors.join(",") : "";
    fields.groups = Array.isArray(fields.groups) ? fields.groups.join(",") : "";
    fields.status = Array.isArray(fields.status) ? fields.status.join(",") : "";
    fields.search = fields.search ? fields.search : "";

    this.okService.download("reports/workerstatus",fields);
  }

}
